<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">教育局会议</div>
        </div>
        <div class="inside_pages_right_content">
            <div class="content_top_three ">
                <div class="inside_pages_right_content_top_right ">
                    <el-select v-model="requestData.signinStatus" placeholder="会议签到状态" size="mini">
                        <el-option label="请选择会议签到状态" value="">
                        </el-option>
                        <el-option v-for="item in $store.state.select.signInStatus" :key="item.id" :label="item.nameOne" :value="item.nameOne">
                        </el-option>
                    </el-select> &nbsp;
                    <el-select v-model="requestData.meetingStatus" placeholder="会议状态" size="mini">
                        <el-option label="请选择会议状态" value="">
                        </el-option>
                        <el-option v-for="item in $store.state.select.meetingStatus" :key="item.id" :label="item.nameOne" :value="item.nameOne">
                        </el-option>
                    </el-select> &nbsp;
                    <el-input v-model.trim="requestData.name"  size="mini" placeholder="请输入会议名称"></el-input> &nbsp;
                    <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                </div>
            </div>
            <div class="content_center_three">
                <el-table :data="responseData.list"  height="100%" border style="width: 100%">
                    <el-table-column prop="id" label="ID" width="120">
                    </el-table-column>

                    <el-table-column prop="name1" label="会议主题">
                    </el-table-column>

                    <el-table-column prop="date1" label="会议时间" width="180">
                        <template slot-scope="rowData">
                            {{$Common.dateFormatDateTwo(rowData.row.date1)}}
                        </template>
                    </el-table-column>

                    <el-table-column prop="meetingStatus" label="会议状态" width="100">
                        <template slot-scope="rowData">
                            {{$store.state.select.meetingStatus[rowData.row.meetingStatus].nameOne}}
                        </template>
                    </el-table-column>

                    <el-table-column prop="meetingStatus" label="签到状态" width="100">
                        <template slot-scope="rowData">
                            {{$store.state.select.signInStatus[rowData.row.signinStatus].nameOne}}
                        </template>
                    </el-table-column>



                    <el-table-column  label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="primary" plain size="mini">
                                编辑
                            </el-button>
                            <el-button type="primary" plain size="mini">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content_bottom_three">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="responseData.pageNum"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
            requestData:{
                schoolId:this.$store.state.schoolId,
                pageSize:20,
                pageNum:1,
                name:'',
                signinStatus:'',
                meetingStatus:'',
            },
            responseData:{
                pageSize:20,
                pageNum:1,
                total:100,
                pages:20,
                list:[
                    {
                        id:1,
                        name1: '会议主题测试',
                        date1: 1593273599,
                        signinStatus: 0,
                        meetingStatus: 2,
                    }
                ],
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }

    },
    created() {},
    mounted() {

    }
};
</script>
